export default __webpack_public_path__ + "0ba36b658731abe5ca39fbc5210b72fd.png";